import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, Files, Film } from 'lucide-react';

function Navbar() {
  const location = useLocation();
  const { pathname } = location;
  const [activeMenu, setActiveMenu] = useState('home-menu');
  const homeRef = useRef(null);
  const articleRef = useRef(null);
  const videoRef = useRef(null);
  const [linePosition, setLinePosition] = useState(null);

  // Update the active menu based on the current path
  useEffect(() => {
    if (pathname.includes('/article/') || pathname.includes('/video/')) {
      if (pathname.includes('/video/') || location.state?.article?.content_type === 'igtt') {
        setActiveMenu('video-menu');
      } else {
        setActiveMenu('article-menu');
      }
    } else {
      switch (pathname) {
        case '/':
          setActiveMenu('home-menu');
          break;
        case '/article':
          setActiveMenu('article-menu');
          break;
        case '/video':
          setActiveMenu('video-menu');
          break;
        default:
          setActiveMenu('home-menu');
      }
    }
  }, [pathname, location.state]);

  // Update line position based on active menu
  useEffect(() => {
    const updateLinePosition = () => {
      let activeElement;
      
      switch (activeMenu) {
        case 'home-menu':
          activeElement = homeRef.current;
          break;
        case 'article-menu':
          activeElement = articleRef.current;
          break;
        case 'video-menu':
          activeElement = videoRef.current;
          break;
        default:
          activeElement = homeRef.current;
      }
      
      if (activeElement) {
        const rect = activeElement.getBoundingClientRect();
        const navRect = activeElement.parentElement.getBoundingClientRect();
        const centerPosition = rect.left + rect.width / 2 - navRect.left;
        setLinePosition(`${centerPosition}px`);
      }
    };
    
    updateLinePosition();
    window.addEventListener('resize', updateLinePosition);
    
    return () => {
      window.removeEventListener('resize', updateLinePosition);
    };
  }, [activeMenu]);

  return (
    <nav className="navbar">
      <div className="nav">
        <Link to="/" id="home-menu" className="menuItem home-menu" ref={homeRef}>
          <span>
            <House size={18} />
          </span>
          Beranda
        </Link>
        <Link to="/article" id="article-menu" className="menuItem article-menu" ref={articleRef}>
          <span>
            <Files size={18} />
          </span>
          Artikel
        </Link>
        <Link to="/video" id="video-menu" className="menuItem video-menu" ref={videoRef}>
          <span>
            <Film size={18} />
          </span>
          Video
        </Link>
        {linePosition && <div className="line" style={{ left: linePosition }}>&#8226;</div>}
      </div>
    </nav>
  );
}

export default Navbar;